import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { MainRoute } from './routes/MainRoute';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <MainRoute />
);

reportWebVitals();
